/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */function r(t,e=!0){return e&&getComputedStyle(t).getPropertyValue("direction").trim()==="rtl"}export{r as isRtl};
